import React from 'react';

const ArrowLeft = ({ className }: { className?: string }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 14.267 13.905">
			<path
				fill="currentColor"
				d="m8.201 12.973-.707.707a.761.761 0 0 1-1.079 0L.225 7.493a.761.761 0 0 1 0-1.079l6.19-6.19a.761.761 0 0 1 1.079 0l.707.707a.765.765 0 0 1-.013 1.092L4.351 5.678h9.152a.762.762 0 0 1 .764.765v1.019a.762.762 0 0 1-.764.764H4.351l3.837 3.655a.76.76 0 0 1 .013 1.092Z"
			/>
		</svg>
	);
};

export default ArrowLeft;
